import { useSelector } from "react-redux";

import { selectAll } from "./selectors";

export const useACHCompany = () => {
  const companies = useSelector(selectAll);
  return companies.length ? companies[0] : undefined;
};
